<quick-dashboard
  [loader]="loader"
  [uid]="'chatbots-dashboard'"
  [heading]="'Assistants'"
  [hideManageButton]="true"
  [columnOptions]="{
    '$$raw': { hidden: true },
    'id': { hidden: true },
    'name': { heading: 'Name', order: 1, renderTemplate: cellName },
    'description': { heading: 'Description', order: 2, hidden: true },
    'tenant': { heading: 'Tenant', order: 3, renderTemplate: cellTenant, outerNgClass: 'cell-width-140' },
    'intents': {
      heading: 'Intents',
      order: 51,
      renderTemplate: cellIntents,
      outerNgClass: 'align-middle cell-width-280'
    },
    'contextVars': {
      heading: 'Context Vars',
      order: 50,
      renderTemplate: cellContextVars,
      outerNgClass: 'align-middle cell-width-320'
     },
    'settings': {
      heading: 'Settings',
      order: 51,
      renderTemplate: cellSettings,
      outerNgClass: 'align-middle cell-width-320'
     },
    'actions': {
      heading: 'Actions',
      order: 60,
      renderTemplate: cellActions,
      outerNgClass: 'align-middle cell-width-140'
     }
  }"
  [hasRouterOutlet]="true"
>
</quick-dashboard>

<ng-template #cellIntents let-cellItem=cellItem>
  <div *ngIf="!cellItem" class="text-secondary fw-light font-size-14">
    -
  </div>
  <ul *ngIf="cellItem" class="text-secondary font-size-14">
    <li *ngFor="let intent of cellItem">
      <div>{{intent['title']}}</div>
    </li>
  </ul>
</ng-template>

<ng-template #cellTenant let-cellItem=cellItem>
  <tenant-id-tag [tenantId]="cellItem"></tenant-id-tag>
</ng-template>

<ng-template #cellContextVars let-cellItem=cellItem let-rowItem=rowItem>
  <ul *ngIf="cellItem">
    <li *ngFor="let v of cellItem">
      <a class="link-underline-light" [routerLink]="['./', rowItem['id'], 'rag-context', v]">{{v}}</a>
      <span *ngIf="isRagVariableDisabled(v, rowItem)">(<span class="text-danger">Disabled</span>)</span>
    </li>
  </ul>
</ng-template>

<ng-template #cellSettings let-cellItem=cellItem>
  <ul *ngIf="cellItem">
    <li>
      Session History:
      <span class="text-primary"
            [ngClass]="{ 'text-danger': !cellItem['useSessionHistory']}"
      >{{cellItem["useSessionHistory"]}}</span>
    </li>
    <li>
      History Cap:
      <span class="text-primary"
            [ngClass]="{ 'text-danger': !cellItem['maxSessionHistorySize']}"
      >{{cellItem["maxSessionHistorySize"]}}</span>
    </li>
    <li *ngIf="cellItem['ragSearch']">
      RAG Search Configs:
      <span class="text-primary">
        {{Object.getOwnPropertyNames(cellItem["ragSearch"]).length}}
      </span>
    </li>
  </ul>
</ng-template>


<ng-template #cellActions let-rowItem=rowItem>
  <div>
    <preview-button ngClass="ms-2" [routerLink]="['./', rowItem['id']]"></preview-button>
    <a [ngClass]="'ms-1'" [routerLink]="['./', rowItem['id'], 'rag-context']">
      <mat-icon class="valign-middle">account_tree</mat-icon>
    </a>
    <a [ngClass]="'ms-1'" [routerLink]="['./', rowItem['id'], 'config']">
      <mat-icon class="valign-middle">tune</mat-icon>
    </a>
  </div>
</ng-template>

<ng-template #cellName let-rowItem=rowItem>
  <div>
    <div>{{rowItem['name']}}</div>
    <div class="text-secondary fw-light font-size-14">{{rowItem['description']}}</div>
  </div>
</ng-template>
